// counts number of times the item appears in the array with the same ticket name 
// when it hits the same item in the list then break and return the filtered index
angular.module('westBerkshireEvents.ticketNumberingFilter').filter('ticketNumbering', function () {
    return function (item, ticketItems) {
        let filteredIndex = 0;

        for (let i = 0; i < ticketItems.length; i++) {
            if (item.tickets && ticketItems[i].tickets) {
                if (item.tickets.name == ticketItems[i].tickets.name) {
                    filteredIndex++;
                    if (item == ticketItems[i]) {
                        break;
                    }
                }
            }
        }
        return filteredIndex;
    }
});


// WEBPACK FOOTER //
// src/public/javascripts/ticket-numbering-filter/ticket_numbering.filter.js